var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[(!_vm.online)?_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n    "+_vm._s(_vm.$t("offline"))+"\n  ")]):_vm._e(),_c('div',{staticClass:"py-5 text-center"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }